import React, { useState, useEffect } from "react";

const GalleryProp = ({ galleryData = [] }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(false);
  
  // Handle modal opening with loading state
  const openModal = (image) => {
    setLoading(true);
    setSelectedImage(image);
    document.body.classList.add('modal-open');
  };

  // Close modal
  const closeModal = () => {
    setSelectedImage(null);
    document.body.classList.remove('modal-open');
  };

  // Handle escape key to close modal
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) closeModal();
    };
    window.addEventListener('keydown', handleEsc);
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, []);

  // Handle image load complete in modal
  const handleImageLoaded = () => {
    setLoading(false);
  };

  return (
    <div className="gallery-bento">
      <div className="bento-grid">
        {galleryData.map((image, index) => (
          <div 
            key={index} 
            className={`bento-item bento-item-${index + 1}`}
            onClick={() => openModal(image)}
          >
            <img
              src={image.grid || image.src}
              alt={image.alt || `Gallery image ${index + 1}`}
              className="img-fluid"
            />
            {/* <div className="bento-overlay">
              <div className="bento-content">
                <h5>{image.title || ''}</h5>
                <p>{image.description || ''}</p>
              </div>
            </div> */}
          </div>
        ))}
      </div>
      
      {/* Enhanced Lightbox Modal */}
      {selectedImage && (
        <div className="gallery-modal" onClick={closeModal}>
          <div className="modal-content-wrapper" onClick={e => e.stopPropagation()}>
            {loading && (
              <div className="modal-loader">
                <div className="spinner"></div>
              </div>
            )}
            <img
              src={selectedImage.src}
              alt={selectedImage.alt || "Gallery image"}
              className="modal-image"
              onLoad={handleImageLoaded}
              style={{ display: loading ? 'none' : 'block' }}
            />
            
            <div className="modal-controls">
              <button 
                className="close-modal" 
                onClick={(e) => {
                  e.stopPropagation();
                  closeModal();
                }}
                aria-label="Close modal"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            
            {selectedImage.title && (
              <div className="modal-caption">
                <h4>{selectedImage.title}</h4>
                {selectedImage.description && <p>{selectedImage.description}</p>}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryProp;